import UCPGraphQL from "./UCPGraphQL";
import axios from "./Axios";
import {UCP_URL} from "../config";

class Order {

    static async getAllOrdersByUid({ personId, tenantId, page, appClientId, offset }) {
        const {data, errors} = await axios()({
            url: UCP_URL + '/all-orders/' + tenantId + '/' + appClientId + '/' +personId + '/' + page + '/'+ offset,
            method: 'GET',
        });
        if (errors && errors.length) {
            throw errors[0]
        }
        return data;
    }
    static async getOrderByOrderId({ personId, tenantId, orderId, appClientId, matchType }) {
        const { data }  = await axios()({
            url: UCP_URL + `/all-orders/${tenantId}/${appClientId}/${personId}/${orderId}?matchType=${matchType}`,
            method: 'GET',
        })
        return data;
    }

    static async getOrderObjectData({ id, tenantId, appClientId}) {
        const {data, errors} = await axios()({
            url: UCP_URL + '/customer-last-order-computed-object/' + tenantId + '/' + appClientId + '/' +id,
            method: 'GET',
        });
        if (errors && errors.length) {
            throw errors[0]
        }
        return data;
    }
}

export default Order
